import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { DateIcon } from 'foundations-assets/icons/components/DateIcon';
import { Flex } from 'foundations-components/components/Flex';
import { MicroDateInput } from 'foundations-components/transitional/components/MicroDateInput';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Text } from 'foundations-components/components/Text';
import { toMomentUTC, fromMoment } from 'foundations-components/transitional/utils/SimpleDate';
import { View } from 'foundations-components/components/View';
import styled from 'foundations-theming/utils';
import { StyledTableCell } from '../../table/StyledTableCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DueDateCell = styled(StyledTableCell).withConfig({
  displayName: "MilestoneDueDateCell__DueDateCell"
})(["&&{padding-inline-start:", ";}"], ({
  theme
}) => theme.space['200']);
const BorderlessInput = props => /*#__PURE__*/_jsx(TextInput, Object.assign({}, props, {
  styled: false,
  disableFocusStyles: true,
  paddingBlock: "100",
  typography: "body-100",
  placeholder: I18n.text('dealPlan.milestones.addDate')
}));
export function MilestoneDateContent({
  milestone,
  onUpdateDueDate,
  paddingInlineStart = '200'
}) {
  const [isAddingDate, setIsAddingDate] = useState(false);
  const dateFormat = 'll';
  const handleDateChange = event => {
    const dateValue = event.target.value;
    const newDueDate = dateValue ? toMomentUTC(dateValue).valueOf() : null;
    onUpdateDueDate(milestone, newDueDate);
  };
  if (!milestone.dueDate && !isAddingDate) {
    return /*#__PURE__*/_jsx(View, {
      cursor: "pointer",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        paddingInlineStart: paddingInlineStart,
        gap: "200",
        onClick: () => setIsAddingDate(true),
        role: "button",
        tabIndex: 0,
        children: [/*#__PURE__*/_jsx(DateIcon, {
          color: "icon-core-disabled"
        }), /*#__PURE__*/_jsx(Text, {
          use: "disabled",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "dealPlan.milestones.addDate"
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(MicroDateInput, {
    value: milestone.dueDate ? fromMoment(I18n.moment.utc(milestone.dueDate)) : undefined,
    onChange: handleDateChange,
    onOpenChange: open => {
      setIsAddingDate(open.target.value);
    },
    open: isAddingDate && !milestone.dueDate ? true : undefined,
    format: dateFormat,
    clearLabel: I18n.text('dealPlan.milestones.clearDate'),
    Input: BorderlessInput
  });
}
export function MilestoneDueDateCell({
  milestone,
  onUpdateDueDate
}) {
  return /*#__PURE__*/_jsx(DueDateCell, {
    children: /*#__PURE__*/_jsx(MilestoneDateContent, {
      milestone: milestone,
      onUpdateDueDate: onUpdateDueDate
    })
  });
}